export const generalConfig = {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_Q5lxT81OA",
    USER_POOL_APP_CLIENT_ID: "7q5714pfce0921lp7qg4s0vtat",
};

export const region = generalConfig.REGION;
export const userPoolId = generalConfig.USER_POOL_ID;
export const userPoolClientId = generalConfig.USER_POOL_APP_CLIENT_ID;
